/*
 * Authors: mariushirjanu
 * Created: 01/07/2022
 */
import { Injectable } from '@angular/core';
import { HttpDataService, IHttpDataCache } from '../../shared/http/http-data.service';

import { IBPProfile, IBPProfileBasic, ICompany, IObject } from '../../../type_definitions/datatypes';

export interface IProfileReport {
  reportLink:string;
}

export interface IBPWizardProgress {
  progress:number;
  completedTabs:string[];
}

@Injectable()
export class BPProfilesDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getBPProfiles():Promise<IBPProfileBasic[]> {
    return this.cache.doGET(
      'rest/bpprofiles/profiles',
      undefined,
      undefined,
      'Error loading BPs'
    );
  }

  public getBPProfileDetail(profileId:number):Promise<IBPProfile> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}`,
      undefined,
      undefined,
      'Error loading selected profile'
    );
  }

  public updateBPProfileDetail(profileId:number, profileDetail:IBPProfile, context?:string):Promise<IBPProfile> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}`,
      undefined,
        profileDetail,
      context ? `Saving ${context}` : undefined,
      'Error updating BP profile detail'
    );
  }

  public getProfileProgress(profileId:number):Promise<IBPWizardProgress> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/progress`,
      undefined,
      undefined,
      'Error loading progress'
    );
  }

  public getProfileReport(profileId:number, params:IObject):Promise<IProfileReport> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/report`,
      params,
      undefined,
      'Error getting profile report'
    );
  }

  public getVendors(lang?:string):Promise<ICompany[]> {
    return this.cache.doGET(
      `rest/bpprofiles/vendors`,
      { lang },
      undefined,
      'Error getting vendors'
    );
  }

  public get bpCompaniesSearchUrl():string {
    return 'rest/bpprofiles/companies';
  }

  public clear():void {
    this.cache.clear();
  }
}